import { render, staticRenderFns } from "./memberUnit.vue?vue&type=template&id=2c3328f0&scoped=true&"
import script from "./memberUnit.vue?vue&type=script&lang=js&"
export * from "./memberUnit.vue?vue&type=script&lang=js&"
import style0 from "./memberUnit.vue?vue&type=style&index=0&id=2c3328f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3328f0",
  null
  
)

export default component.exports